import { render, staticRenderFns } from "./LandRegisterTab.vue?vue&type=template&id=7c43c775&scoped=true"
import script from "./LandRegisterTab.vue?vue&type=script&lang=js"
export * from "./LandRegisterTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c43c775",
  null
  
)

export default component.exports